export default {
  // General
  app_name: 'mvplan',
  calculate: 'Calculer la décompression',
  save: 'Enregistrer',
  cancel: 'Annuler',
  add: 'Ajouter',
  edit: 'Modifier',
  delete: 'Supprimer',
  reset: 'Réinitialiser',
  confirm_reset: 'Réinitialiser tous les paramètres ?',
  confirm_delete: 'Supprimer cet élément ?',

  // Navigation
  nav_plan: 'Plan',
  nav_gases: 'Gaz',
  nav_profile: 'Profil',
  nav_settings: 'Réglages',
  nav_day: 'Journée',

  // Journée de plongée
  day_title: 'Journée de plongée',
  day_empty: 'Aucune plongée dans cette journée.',
  day_empty_hint: 'Ajoutez la plongée de l\'écran Plan pour commencer une série.',
  day_add_current: 'Ajouter la plongée en cours',
  day_add_needs_segments: 'L\'écran Plan ne contient aucun segment : rien à ajouter.',
  day_ask_surface_interval: 'Intervalle de surface avant cette plongée, en minutes :',
  day_invalid_surface_interval: 'Saisissez un intervalle de surface supérieur ou égal à 0 min.',
  day_surface_interval: 'Intervalle de surface',
  day_dive_label_placeholder: 'Nom de la plongée (facultatif)',
  day_calculate: 'Calculer la journée',
  day_clear: 'Vider la journée',
  day_confirm_clear: 'Supprimer toutes les plongées de cette journée ?',
  day_remove_dive: 'Supprimer cette plongée',
  day_confirm_remove: 'Les plongées suivantes sont chaînées sur celle-ci et devront être recalculées.',
  day_dive_not_computed: 'Pas encore calculée',
  day_dive_stale: 'Calculée avant une modification : ce plan ne décrit plus la série.',
  day_dive_refused: 'Plongée refusée, vérifiez les plongées précédentes de la série.',
  day_dives_refused: '{count} plongée(s) n\'ont pas pu être planifiées. Les plongées suivantes sont chaînées sur une plongée qui n\'existe pas.',
  day_summary: 'Total de la journée',
  day_dives_count: 'Plongées',
  day_summary_partial: 'Les totaux portent sur les {computed} plongée(s) calculée(s) sur {total}.',
  day_editing_dive: 'Vous modifiez la plongée {number} de la journée.',
  day_save_into_day: 'Enregistrer dans la journée',
  day_detach: 'Détacher',
  day_dive_number: 'Plongée {number} sur {total}',
  day_first_dive: 'Première plongée de la journée',
  day_nothing_to_export: 'Aucune plongée de cette journée n\'a été calculée : rien à exporter.',
  day_export_failed: 'Le document n\'a pas pu être produit. Réessayez, et regardez la console du navigateur pour en connaître la raison.',

  // Saved days
  saved_days_title: 'Journées enregistrées',
  saved_days_save: 'Enregistrer la journée',
  saved_days_saved: 'Journée enregistrée',
  saved_days_save_failed: 'Cette journée n\'a pas pu être enregistrée : elle ne contient aucune plongée, ou le stockage est plein.',
  saved_days_name_placeholder: 'ex. Port-Cros, samedi',
  saved_days_empty: 'Aucune journée enregistrée.',
  saved_days_empty_hint: 'Composez une journée de plongée, puis enregistrez-la pour la retrouver ici.',
  saved_days_confirm_delete: 'Supprimer cette journée ?',
  saved_days_import_error: 'Ce fichier n\'est pas une journée de plongée exportée par mvplan.',

  // Settings
  settings_algorithm: 'Algorithme',
  settings_gf: 'Facteurs de gradient',
  settings_gf_low: 'GF Bas',
  settings_gf_high: 'GF Haut',
  settings_rates: 'Vitesses & Paliers',
  settings_descent: 'Descente',
  settings_ascent: 'Remontée',
  settings_deco_ascent: 'Entre paliers',
  settings_last_stop_ascent: 'Remontée finale',
  settings_last_stop: 'Dernier palier',
  settings_safety_stop: 'Palier de sécurité quand aucune déco n\'est due (min, 0 = aucun)',
  settings_rmv: 'Conso. équiv. surface (RMV / SAC)',
  settings_rmv_bottom: 'Fond',
  settings_rmv_deco: 'Déco / Bailout',
  settings_ccr: 'Mode CCR',
  settings_setpoint_mode: 'Mode Setpoint',
  settings_setpoint_fixed: 'Fixe',
  settings_setpoint_dynamic: 'Dynamique',
  settings_ppo2: 'Limites ppO2',
  settings_ppo2_working: 'Travail',
  settings_ppo2_deco: 'Déco',
  settings_display: 'Affichage',
  settings_units: 'Unités',
  settings_units_metric: 'Métriques (m, bar)',
  settings_units_imperial: 'Impériales (ft, psi)',
  settings_theme: 'Thème',
  settings_theme_dark: 'Sombre',
  settings_theme_light: 'Clair',
  settings_language: 'Langue',
  settings_divers: 'Plongeurs',
  settings_divers_hint: 'Noms imprimés sur le PDF (séparés par des virgules)',
  settings_dive_site: 'Site de plongée',
  settings_dive_site_placeholder: 'ex. Blue Hole, Dahab',
  settings_bailout: 'Bailout',
  settings_bail_delay: 'Délai gestion bailout (min)',
  settings_bail_delay_hint: 'Temps au fond avant remontée en bailout',
  settings_rmv_stress: 'RMV/SAC Stress',
  settings_stress_until: 'Stress jusqu\'à',
  settings_stress_first_stop: 'Premier palier',
  settings_stress_gas_switch: 'Changement de gaz',
  settings_stress_surface: 'Surface',
  settings_time_and_gas: 'Temps et changements de gaz',
  settings_descent_included: 'Descente incluse',
  settings_descent_included_hint: 'La durée de descente est incluse dans la durée du segment',
  settings_gas_switch_duration: 'Durée changement de gaz',
  settings_gas_switch_at_stop: 'Changer de gaz au palier uniquement',
  settings_gas_switch_at_stop_hint: 'Si désactivé, le changement se fait dès que la MOD le permet (plus optimal)',
  settings_gf_presets: 'Presets GF',
  settings_gf_presets_hint: 'Accès rapide dans la vue Plan',
  settings_gf_add_preset: 'Ajouter un preset',
  settings_gf_preset_name: 'Nom',
  settings_gf_custom: 'Personnalisé',
  settings_environment: 'Environnement',
  settings_gas_temp: 'Temp. gaz',
  settings_water_type: 'Type d\'eau',
  settings_water_salt: 'Eau de mer',
  settings_water_fresh: 'Eau douce',
  settings_water_brackish: 'Eau saumâtre',
  settings_water_red_sea: 'Mer Rouge',
  settings_water_custom: 'Densité personnalisée',
  settings_water_density: 'Densité de l\'eau',
  settings_water_density_hint: 'La densité de l\'eau change la pression réellement subie à une profondeur donnée, donc la durée des paliers. Repères : 10000 en eau douce, 10150 en eau saumâtre, 10300 en mer, 10400 en mer Rouge (10300 correspond à 1.03 kg/l). Valeurs acceptées : {min} à {max}.',
  settings_altitude: 'Altitude',
  settings_environment_hint: 'Temp. gaz = température pulmonaire pour le calcul de densité (~35°C). L\'altitude et le type d\'eau modifient aussi le calcul de décompression.',
  settings_alerts: 'Alertes de sécurité',
  settings_alerts_hint: 'Désactivez certaines alertes pour les plongeurs expérimentés',
  settings_alerts_narcosis: 'Alertes narcose (END)',
  settings_alerts_density: 'Alertes densité (CO2)',
  settings_alerts_show_density: 'Toujours afficher la densité du gaz',
  settings_ccr_flush: 'Rinçages de boucle (CCR)',
  settings_ccr_flush_hint: 'Ajoute un éditeur de rinçages à l\'écran de plan pour les plongées recycleur.',
  settings_ccr_flush_duration: 'Durée de rinçage par défaut (min)',
  settings_ccr_o2_flush: 'Fin de plongée à 100% d\'oxygène',
  settings_ccr_o2_flush_hint: 'À la profondeur choisie, la boucle passe à l\'oxygène pur et y reste jusqu\'à la surface.',
  settings_ccr_o2_flush_depth: 'Profondeur (m)',
  settings_ccr_o2_flush_time: 'Durée du rinçage (min)',
  settings_ccr_o2_flush_invalid: 'Profondeur ou durée inutilisable.',
  settings_alerts_icd: 'Alertes ICD (oreille interne)',
  settings_pdf: 'Export PDF',
  settings_pdf_include_profile: 'Inclure le profil de plongée',
  settings_pdf_include_profile_hint: 'Désactiver pour tenir sur une seule page A4',
  settings_school_mode: 'Mode école',
  settings_school_mode_hint: 'Comparer les presets GF sur le graphique de profil',
  settings_chart_scale: 'Échelle du graphique',
  settings_school_presets: 'Presets à comparer',
  profile_school_compare: 'Comparaison GF',
  profile_school_tts: 'TTS',
  profile_school_stops: 'Paliers',

  // Gases
  gases_title: 'Mélanges',
  gases_bailout: 'Bailout / Réchappe',
  gases_diluents: 'Diluants',
  gases_name: 'Nom',
  gases_mod: 'PMU',
  gases_end: 'PEN',
  gases_ppo2_max: 'ppO2 max',
  gases_use_bailout: 'Utiliser comme bailout',
  gases_tank_config: 'Configuration bloc',
  gases_volume: 'Volume (L)',
  gases_pressure: 'Pression (bar)',
  gases_capacity: 'Capacité',

  // Plan
  plan_segments: 'Segments de plongée',
  plan_depth: 'Profondeur',
  plan_time: 'Durée',
  plan_runtime: 'Runtime',
  plan_gas: 'Gaz',
  plan_setpoint: 'SP',
  plan_no_segments: 'Aucun segment. Ajoutez-en un pour commencer.',
  plan_config: 'Configuration',
  plan_ccr: 'Plan CCR',
  plan_bailout: 'Simulation de sortie sur Bailout',
  plan_deco: 'Planification de la plongée',
  plan_no_deco: 'Pas de décompression requise',
  plan_stops_summary: 'Résumé des paliers',
  duration_hours_minutes: '{h} h {m}',
  duration_hours: '{h} h',
  duration_minutes: '{m} min',
  plan_desat_sea_level: 'Si vous restez au niveau de la mer, vous aurez totalement désaturé {time} après la sortie de l\'eau.',
  plan_desat_altitude: 'Si vous restez à {altitude} m d\'altitude, vous aurez totalement désaturé {time} après la sortie de l\'eau.',
  plan_desat_over: 'La désaturation complète demande plus de {time} après la sortie de l\'eau.',
  plan_no_fly: 'Avion (DAN)',
  plan_no_fly_minimum: '> {time}',
  plan_no_fly_dan_rule: 'Délai avant vol, recommandations du consensus DAN : un intervalle de surface d\'au moins {noStop} pour une plongée unique sans décompression ; un intervalle de surface d\'au moins {multiDay} pour de la plongée répétitive sur plusieurs jours ; substantiellement plus de {longer} après une plongée à décompression obligatoire, ou aux mélanges héliox et trimix. Ce n\'est pas un calcul de désaturation.',
  plan_no_fly_dan_case_no_stop: 'Cette plongée relève du premier cas : une plongée unique sans palier.',
  plan_no_fly_dan_case_repetitive: 'Cette plongée relève du deuxième cas : plongée répétitive.',
  plan_no_fly_dan_case_deco: 'Cette plongée relève du troisième cas : décompression obligatoire. Le délai affiché est un plancher à dépasser, pas une valeur recommandée.',
  plan_no_fly_dan_case_helium: 'Cette plongée relève du troisième cas : mélange à l\'hélium. Le délai affiché est un plancher à dépasser, pas une valeur recommandée.',
  plan_no_fly_dan_source: 'Source : DAN, Guidelines for Flying After Diving, consensus du Flying After Recreational Diving Workshop (2002). Ces essais ont été menés en caisson sec sur des sujets au repos : des délais plus longs peuvent être nécessaires en immersion et à l\'effort.',
  plan_tts: 'TTS',
  plan_cns: 'CNS',
  plan_otu: 'OTU',
  plan_cns_series: 'CNS (journée)',
  plan_otu_series: 'OTU (journée)',
  plan_gas_requirements: 'Besoins en gaz bailout',
  plan_gas_consumption: 'Consommation de gaz',
  plan_liters: 'Litres',
  plan_type: 'Type',
  plan_ppo2: 'ppO2',
  plan_density: 'Densité',
  plan_tissue: 'Tissu / Gaz directeur',
  plan_flush: 'Rinçages de boucle',
  plan_flush_hint: 'Rinçages volontaires de la boucle pendant la remontée, du plus profond au plus superficiel. Pendant un rinçage la boucle est remplie du mélange choisi à la pression ambiante, et non réglée sur le setpoint.',
  plan_flush_add: 'Ajouter un rinçage',
  plan_flush_none: 'Aucun rinçage prévu',
  plan_flush_depth: 'Profondeur',
  plan_flush_gas: 'Rincer au',
  plan_flush_time: 'Durée',
  plan_flush_keep: 'Garder ce mélange',
  plan_flush_keep_hint: 'La boucle reste sur le mélange rincé jusqu\'à la surface, ce qui est la purge volontaire de l\'hélium avant la décompression. Décochée, elle repasse sur le diluant en service : un rinçage est un geste, pas un changement de gaz.',
  plan_flush_remove: 'Supprimer',
  plan_flush_figures: '{gas} à {depth} m : ppO2 {ppO2} bar, PEN {end} m, densité {density} g/L',
  plan_o2_flush_row: 'Fin à l\'oxygène : {time} min de rinçage à {depth} m, boucle gardée à l\'oxygène jusqu\'à la surface.',
  plan_o2_flush_source: 'Réglé dans les réglages CCR, non modifiable ici.',
  plan_o2_flush_skipped_setting: 'La fin à l\'oxygène des réglages porte une profondeur ou une durée inutilisable : elle n\'est pas retenue.',
  plan_o2_flush_skipped_clash: 'La fin à l\'oxygène des réglages s\'efface à {depth} m : un rinçage que vous avez saisi y est déjà prévu.',
  plan_o2_flush_skipped_too_deep: 'La fin à l\'oxygène prévue à {depth} m n\'est pas retenue : cette plongée ne descend jamais sous {maxDepth} m.',
  plan_flush_helper: 'Calculer',
  plan_flush_helper_title: 'Profondeur du rinçage',
  plan_flush_helper_hint: 'Dites ce que vous visez et la profondeur qui le donne est calculée, pour le mélange de ce rinçage et pour l\'eau et l\'altitude du site.',
  plan_flush_helper_mix: 'Mélange de rinçage',
  plan_flush_helper_target: 'Viser',
  plan_flush_target_ppo2: 'ppO2 (bar)',
  plan_flush_target_end: 'PEN (m)',
  plan_flush_helper_result: '{depth} m ({exact} m exactement)',
  plan_flush_helper_rounding: 'Arrondi au mètre le moins profond, donc les valeurs ci-dessous sont celles que le plan tiendra.',
  plan_flush_helper_apply: 'Utiliser cette profondeur',
  plan_flush_helper_unreachable: 'Aucune profondeur ne donne cela avec ce mélange.',
  plan_flush_helper_deeper: 'Plus profond que le fond à {maxDepth} m : un rinçage se fait à la remontée.',
  plan_flush_helper_no_nitrogen: 'Ce mélange ne contient pas d\'azote : sa PEN est nulle à toute profondeur.',
  plan_flush_helper_band: 'Hors de votre bande de travail {min} - {max} bar.',
  plan_descent: 'Descente',
  plan_ascent: 'Remontée',
  plan_bottom: 'Fond',
  plan_stop: 'Palier',
  plan_total_runtime: 'Runtime total',
  plan_deco_time: 'Temps déco',
  plan_max_depth: 'Prof. max',
  plan_bottom_time: 'Temps fond',
  plan_based_on_rmv: 'Estimations basées sur RMV',
  plan_insufficient_gas: 'Un ou plusieurs blocs ont une capacité insuffisante pour cette plongée !',
  plan_bars_needed: 'bars requis',

  // Profile
  profile_title: 'Profil de plongée',
  profile_saturation: 'Saturation tissulaire',
  profile_tap_details: 'Toucher pour détails',
  profile_ceiling: 'Plafond',
  profile_surface: 'Surface',
  profile_residual: 'N2 résiduel',
  profile_calculate_hint: 'Calculez un plan pour voir le profil',
  profile_fullscreen: 'Plein écran',


  // Units
  unit_meters: 'm',
  unit_feet: 'ft',
  unit_minutes: 'min',
  unit_bar: 'bar',
  unit_psi: 'psi',
  unit_lpm: 'L/min',

  // Additional Plan
  plan_add_segment: 'Ajouter un segment',
  plan_edit_segment: 'Modifier le segment',
  plan_diluent: 'Diluant',
  plan_dynamic_setpoint_info: 'Mode dynamique actif',
  plan_override_setpoint: 'Forcer un setpoint fixe (optionnel)',
  plan_setpoint_auto: 'Auto',
  plan_mode: 'Mode',
  plan_algorithm: 'Algorithme',
  plan_export_pdf: 'PDF',
  plan_save_html: 'Export HTML',
  plan_calculate_first: 'Calculez d\'abord un plan',
  plan_segment_for: '{depth}m pendant {time} min',
  plan_gas_at_sp: '{gas} @ SP{sp}',
  plan_tank: 'Bloc',
  plan_needed: 'Requis',
  plan_status: 'Statut',
  plan_insufficient: 'INSUFFISANT',
  plan_gas_tight: 'JUSTE',
  plan_ok: 'OK',
  plan_need_more: 'Il manque {liters}L ({bars} bar)',
  plan_left: '{liters}L restants ({bars} bar)',
  plan_need_more_liters: 'Il manque {liters}L',
  plan_left_liters: '{liters}L restants',
  plan_gas_unused: 'NON RESPIRÉ',
  plan_gas_unused_detail: '{liters}L emportés, jamais ouverts par ce plan',
  plan_gas_backup: 'Renfort : {names}',

  // Gases additional
  gases_name_auto: 'Nom (auto si vide)',
  gases_auto_label: 'Label automatique',
  gases_n2_calc: 'N2 % (calculé)',
  gases_end_at_mod: 'PEN @ PMU',
  gases_confirm_delete: 'Supprimer ce gaz ?',
  gases_confirm_delete_diluent: 'Supprimer ce diluant ?',
  gases_only_diluent: 'Impossible de supprimer le seul diluant',
  gases_form_invalid: 'Valeurs inutilisables : O2 au-dessus de 0 % et au plus 100 %, He de 0 % à moins de 100 %, leur somme au plus 100 % ; limite de ppO2, volume et pression du bloc supérieurs à 0.',
  plan_segment_invalid: 'Saisissez une profondeur de 1 à 200 m, une durée de 1 à 999 min, et un setpoint de 0,7 à 1,6 bar.',

  // Segment types
  segment_bail: 'BAILOUT',
  segment_desc: 'Desc',
  segment_asc: 'Rem',
  segment_bottom: 'Fond',
  segment_stop: 'Palier',
  segment_gas_change: 'Chgt gaz',
  segment_diluent_change: 'Chgt dil.',
  segment_flush: 'Rinçage',
  segment_safety_stop: 'Sécurité',

  // Saved Plans
  nav_saved: 'Favoris',
  saved_plans_title: 'Plans sauvegardés',
  saved_plans_save: 'Sauvegarder',
  saved_plans_saved: 'Plan sauvegardé !',
  saved_plans_empty: 'Aucun plan sauvegardé',
  saved_plans_empty_hint: 'Calculez un plan et sauvegardez-le pour plus tard',
  saved_plans_load: 'Charger',
  saved_plans_rename: 'Renommer',
  saved_plans_duplicate: 'Dupliquer',
  saved_plans_export: 'Exporter',
  saved_plans_confirm_delete: 'Supprimer ce plan ?',
  saved_plans_import: 'Importer',
  saved_plans_import_error: 'Échec de l\'importation',
  saved_plans_name_label: 'Nom du plan',
  saved_plans_name_placeholder: 'Entrez le nom du plan',
  plan_share: 'Partager',
  feature_next_version: 'Disponible dans la prochaine version',

  // Dive environment carried by a plan: named in the exports and in the saved
  // plan list, and flagged when the plan on screen was computed for another one
  plan_environment_changed: 'Ce plan a été calculé pour une autre eau ou une autre altitude. Relancez le calcul avant de le plonger.',
  // Any other input the calculation reads (gradient factors, rates, ppO2
  // limits, gases, rebreather...) changed after the plan was computed
  plan_inputs_changed: 'Ce plan a été calculé avec d\'autres paramètres de plongée. Relancez le calcul avant de le plonger.',
  export_environment: 'Environnement',
  saved_plan_environment: 'Environnement',

  // PDF Export
  pdf_title: 'Plan de plongée - mvplan',
  pdf_exporting: 'Génération du PDF...',
  pdf_generated: 'Généré le',
  pdf_mode_oc: 'Circuit ouvert',
  pdf_footer_generated: 'Généré par mvplan - Planificateur de plongée technique',
  pdf_footer_verify: 'Vérifiez toujours votre plan et emportez des tables de secours',

  // PDF format choice
  pdf_choose_format: 'Format du PDF',
  pdf_choose_format_hint: 'Choisissez le type de document à exporter',
  pdf_format_complete: 'Complet',
  pdf_format_complete_hint: 'Rapport détaillé multi-pages (tableaux, profil, gaz)',
  pdf_format_condensed: 'Condensé (1 page)',
  pdf_format_condensed_hint: 'Fiche de planification imprimable sur une seule page',

  // PDF condensed form
  pdf_form_title: 'Planification de plongée',
  pdf_form_date: 'Date',
  pdf_form_team: 'Palanquée n°',
  pdf_form_diver: 'Plongeur',
  pdf_form_lastname: 'Prén., Nom',
  pdf_form_machine: 'Machine',
  pdf_form_gf: 'Grad. Fac.',
  pdf_form_runtime_title: 'Run Time',
  pdf_form_planned_depth: 'Profondeur prévue',
  pdf_form_planned_bottom: 'Durée fond prévue',
  pdf_form_palier: 'Prof palier',
  pdf_form_descent: 'Descente',
  pdf_form_bottom: 'Fond',
  pdf_form_duration: 'Durée',
  pdf_form_cumul: 'Cumul',
  pdf_form_mutualized: 'Mutualisé',
  pdf_form_vol_liters: '% / Vol. en Litres',
  pdf_form_col_pct: '%',
  pdf_form_col_vol: 'Vol.',
  pdf_form_col_press: 'Prs.',
  pdf_form_col_liters: 'Lit.',
  pdf_form_yes: 'oui',
  pdf_form_no: 'non',
  pdf_form_gas_switch_legend: 'changement de gaz',
  pdf_form_gas_verdict_legend: "Case Lit. du plongeur 1 : vert = OK, orange = juste, rouge = insuffisant pour la remontée au bailout, gris = non respiré. Détail chiffré dans la colonne de droite.",
  pdf_form_dtr: 'DTR',

  // Safety Alerts
  alerts_summary_title: 'Points d\'attention sur ce plan',
  alert_hypoxia: 'ppO2 {value} bar sous le minimum de 0.16 bar : ce mélange n\'est pas respirable à cette profondeur. Prévoyez un gaz plus riche en oxygène.',
  alert_hyperoxia: 'ppO2 {value} bar au-dessus du maximum de 1.6 bar. Réduisez la part d\'oxygène ou utilisez ce gaz moins profond.',
  alert_end_critical: 'END {value}m au-delà de la limite de 40m. Ajoutez de l\'hélium au mélange fond pour réduire la narcose.',
  alert_end_high: 'END {value}m au-dessus des 30m recommandés. Un mélange plus riche en hélium réduit la narcose.',
  alert_density_critical: 'Densité du gaz {value} g/L au-dessus des 6.2 g/L recommandés : la respiration peut devenir difficile à cette profondeur. Ajoutez de l\'hélium au mélange fond.',
  alert_density_high: 'Densité du gaz {value} g/L au-dessus des 5.2 g/L conseillés en recycleur. Limitez les efforts ou enrichissez le diluant en hélium.',
  alert_narcosis_increase: 'La ppN2 passe de {ccrValue} à {value} bar au passage sur bailout : narcose plus marquée qu\'en recycleur. Un bailout plus riche en hélium adoucit la transition.',
  alert_end_increase: 'L\'END passe de {ccrValue}m à {value}m au passage sur bailout. Un bailout plus riche en hélium réduit cet écart.',
  alert_icd_risk: 'L\'hélium chute de {prevValue}% à {value}% à ce changement de gaz. Une transition plus progressive (mélange intermédiaire) évite la contre-diffusion isobare.',
  alert_ceiling_violation: 'Ce profil remonte à {depth}m alors que le plafond de déco est à {ceiling}m. Restez sous le plafond et prolongez le palier avant de remonter.',
  alert_stop_time_truncated: 'Palier à {depth}m limité à {time} min : la limite interne de calcul a été atteinte sans dégager le plafond. Ce plan est incomplet, ne le suivez pas - réduisez le temps fond, ajoutez un gaz de déco ou augmentez le GF haut.',
  alert_runtime_limit: 'Calcul interrompu à la limite interne de runtime de {runtime} min : ce plan est incomplet, ne le suivez pas - raccourcissez la plongée ou ajoutez un gaz de déco plus riche.',
  alert_entry_ceiling: 'Plafond à {ceiling}m au début de cette plongée, avec les facteurs de gradient réglés ici : l\'intervalle de surface de {interval} min ne dégage pas la plongée précédente, le plongeur doit déjà un palier avant de se remettre à l\'eau. Ce plan le rattrape à la remontée - allongez l\'intervalle avant de plonger.',
  alert_residual_state_unloaded: 'État tissulaire résiduel sans aucune saturation : il prétend suivre une plongée alors qu\'aucun compartiment n\'est au-dessus de son niveau de repos. Ce plan est donc plus court que la même plongée calculée sur des tissus vierges - ne le suivez pas, recalculez la plongée précédente.',
  alert_default_gas_fallback: 'Aucun mélange actif : ce plan a été calculé à l\'air par défaut. Il ne correspond pas aux gaz que vous avez configurés - activez au moins un mélange dans la vue Gaz et relancez le calcul avant de plonger.',
  alert_gas_above_mod: 'Aucun gaz emporté n\'atteint {depth}m sous la limite de ppO2 de {limit} bar qui s\'y applique : ce plan y fait respirer {gas}, au-delà de sa MOD de {mod}m à cette limite, à une ppO2 de {ppO2} bar. C\'est le mélange le plus pauvre de votre liste, retenu par défaut et non par vous - emportez un mélange adapté à cette profondeur, ou relevez la limite, avant de plonger.',
  alert_gas_switch_on_empty: 'La bouteille de {gas} se vide à {depth}m : le changement de gaz qui y apparaît n\'est pas une bascule de décompression que vous avez prévue, c\'est le plan qui passe à ce qu\'il reste. Emportez davantage de ce mélange, ou prévoyez votre propre bascule au-dessus de cette profondeur, avant de plonger.',
  alert_gas_exhausted: 'Toutes les bouteilles utilisables à {depth}m sont vides : au-delà, ce plan fait respirer du gaz que vous n\'emportez plus. Ajoutez de la capacité, ou un mélange qui atteint cette profondeur, avant de plonger.',
  alert_gas_insufficient: 'Les blocs de {gas} contiennent {capacity} L et ce plan en consomme {liters} L : il manque {missing} L. Emportez-en davantage, ou planifiez une plongée plus courte, avant de plonger.',
  alert_flush_not_reached: 'Le rinçage prévu à {depth}m n\'a jamais lieu : la remontée finale démarre à {ascentStart}m, au-dessus. Remontez le rinçage, ou faites-en le dernier niveau de la plongée.',
  alert_flush_ppo2: 'Le rinçage de {depth}m au {gas} met la boucle à {ppO2} bar d\'oxygène, hors de votre plage de travail {min} - {max} bar. Pendant un rinçage le setpoint ne tient plus : la boucle vaut ce que le mélange donne à cette profondeur.',
  alert_o2_flush_too_deep: 'La fin à l\'oxygène prévue à {depth}m n\'a jamais lieu : cette plongée ne descend jamais sous {maxDepth}m, aucune remontée ne passe par cette profondeur.',

  // Plan validation errors
  plan_error_title: 'Plan impossible à calculer',
  plan_error_no_segments: 'Aucun segment de plongée : ajoutez au moins un segment avec une profondeur et une durée.',
  plan_error_invalid_depth: 'Profondeur invalide : saisissez une profondeur supérieure ou égale à 0 m pour chaque segment (0 m correspond à un intervalle de surface).',
  plan_error_invalid_time: 'Durée invalide : saisissez une durée supérieure ou égale à 0 min pour chaque segment.',
  plan_error_invalid_gf: 'Facteurs de gradient invalides : le GF bas doit être inférieur ou égal au GF haut, et les deux strictement supérieurs à 0% et au plus égaux à 100%.',
  plan_error_invalid_gas: 'Mélange gazeux invalide : la fraction O2 doit être strictement supérieure à 0% et au plus égale à 100%, la fraction He comprise entre 0% et moins de 100%, et leur somme ne doit pas dépasser 100%.',
  plan_error_no_diluent: 'Aucun diluant valide : choisissez un diluant pour la plongée recycleur dans la vue Gaz.',
  plan_error_invalid_setpoint: 'Setpoint invalide : saisissez un setpoint ppO2 compris entre 0.4 et 1.6 bar, bornes incluses.',
  plan_error_no_bailout_gas: 'Aucun gaz de secours actif : activez au moins un gaz bailout dans la vue Gaz pour calculer la sortie sur bailout.',
  plan_error_invalid_config: 'Réglage du planificateur invalide : une vitesse de remontée ou de descente, une profondeur de palier ou une limite de ppO2 est hors plage. Vérifiez les réglages du planificateur avant de relancer le calcul.',
  plan_error_invalid_tissue_state: 'État tissulaire résiduel inutilisable : la plongée précédente de la série n\'a pas pu être relue. Recalculez la plongée précédente avant de planifier celle-ci.',
  plan_error_invalid_surface_interval: 'Intervalle de surface invalide : saisissez une durée supérieure ou égale à 0 min entre la plongée précédente et celle-ci.',
  plan_error_invalid_flush: 'Rinçage de boucle invalide : donnez à chaque rinçage une profondeur au-dessus du fond, une durée supérieure à 0 min, et un seul rinçage par profondeur.',
  plan_error_time_shorter_than_descent: 'Durée de segment plus courte que sa descente : atteindre {depth} m demande {descentTime} min à la vitesse de descente réglée, et le segment ne dure que {time} min. Le temps de descente est inclus dans la durée du segment (voir réglages) : saisissez une durée plus longue, ou décochez cette option.',
  plan_error_segment_gas_unavailable: 'Le segment {index} ({depth} m) est planifié sur {gas}, qui est désactivé ou n\'existe plus. Activez ce gaz dans l\'écran Gaz, ou choisissez-en un autre pour le segment.',
  plan_error_no_bailout_point: 'Le plan recycleur ne porte pas de point de bailout : il n\'a pas été produit par cette version du planificateur. Recalculez le plan recycleur avant son bailout.',

  // Dive Info
  plan_notes: 'Notes',
  plan_notes_placeholder: 'Ajoutez des notes pour le plan imprimé (rappels, consignes, informations pour le DP etc.)',
  plan_divers_placeholder: 'Plongeurs pour cette plongée',

  // App Store Links
  app_available_on: 'Disponible sur :',
  app_get_ios: 'Télécharger sur l\'App Store',
  app_get_android: 'Télécharger sur Google Play',

  // Tissue compartment descriptions
  tissue_desc_1: 'Sang, moelle épinière',
  tissue_desc_2: 'Sang, cerveau',
  tissue_desc_3: 'Cerveau, tissu nerveux',
  tissue_desc_4: 'Muscles bien irrigués',
  tissue_desc_5: 'Peau, viscères',
  tissue_desc_6: 'Muscles, organes',
  tissue_desc_7: 'Muscles',
  tissue_desc_8: 'Muscles, ligaments',
  tissue_desc_9: 'Tendons, tissu conjonctif',
  tissue_desc_10: 'Cartilages',
  tissue_desc_11: 'Cartilages, os',
  tissue_desc_12: 'Os, articulations',
  tissue_desc_13: 'Os, graisse',
  tissue_desc_14: 'Tissu adipeux',
  tissue_desc_15: 'Graisse, moelle osseuse',
  tissue_desc_16: 'Graisse, moelle osseuse',
  tissue_halftime: 'Demi-temps',
  tissue_speed_fast: 'tissu rapide',
  tissue_speed_medium: 'tissu moyen',
  tissue_speed_slow: 'tissu lent',
  tissue_leading: 'Compartiment directeur',
  tissue_leading_detail: '{tissue} (C{num}) impose votre plafond à {ceiling}m - chargé à {gf}% (GF {gfLow}/{gfHigh}, limite ici : {gfLimit}%)',
  tissue_leading_no_ceiling: '{tissue} (C{num}) est le plus chargé - chargé à {gf}% (GF {gfLow}/{gfHigh}, limite ici : {gfLimit}%)',
  tissue_detail_title: 'Détail du compartiment',
  tissue_detail_coefficients: 'Coefficients {algo} : a={a} (tolérance à la sursaturation), b={b} (sensibilité à la profondeur). Constantes empiriques de Bühlmann - les tissus rapides (C1) tolèrent plus (a=1.17), les tissus lents (C16) moins (a=0.23).',
  tissue_detail_saturation: 'Saturation',
  tissue_detail_gf_actual: 'GF réel',
  tissue_detail_no_supersaturation: 'Pas de sursaturation',
  tissue_detail_undersaturated: 'Ce compartiment n\'est pas en sursaturation : la pression tissulaire est inférieure à la pression ambiante. Le concept de GF ne s\'applique que lorsque le tissu est en sursaturation (en remontée ou à un palier).',
  tissue_detail_explanation: '{saturation}% de saturation ne signifie pas {saturation}% de GF. Le GF ({gfActual}%) mesure la fraction de marge utilisée entre la pression ambiante et la M-value. Avec un GF High de {gfHigh}%, une saturation de {saturation}% est attendue.',
  tissue_detail_explanation_gf_low: 'GF Low ({gfLow}%) détermine la profondeur du premier palier de décompression. C\'est ici que l\'algorithme autorise le plongeur à s\'arrêter pour la première fois en remontée : le compartiment directeur utilise {gfUsed}% de sa marge entre pression ambiante et M-value. Plus le GF Low est bas, plus les paliers commencent profond.',
  tissue_detail_explanation_interpolated: 'Entre le premier palier et la surface, le GF est interpolé linéairement de GF Low ({gfLow}%) à GF High ({gfHigh}%). À cette profondeur, la limite appliquée est {gfUsed}%. Le GF réel de ce compartiment est {gfActual}%.',

  // Disclaimer
  disclaimer_title: 'Avertissement',
  disclaimer_text: 'Ce logiciel est uniquement une aide à la planification de plongée. Il ne remplace ni la formation, ni l\'expérience, ni le jugement du plongeur. Les auteurs déclinent toute responsabilité en cas d\'accident ou d\'incident. Vérifiez toujours votre plan avec d\'autres outils et emportez des tables de secours.',
  disclaimer_short: 'Aide à la planification uniquement - ne remplace ni la formation ni le jugement - aucune responsabilité acceptée',

  // Soutenir le projet
  support_nav: 'Soutenir le projet',
  support_nav_website: 'Le projet',
  support_title: 'Soutenir MV-Plan',
  support_intro: 'MV-Plan est un logiciel libre. Pas de publicité, pas de compte à créer, aucune donnée collectée, et toutes les fonctions sont accessibles à tout le monde. Cela ne changera pas.',
  support_costs_title: 'Ce que le projet coûte',
  support_cost_apple: 'Compte développeur Apple : 99 USD par an, à payer même si l\'application est gratuite.',
  support_cost_google: 'Compte développeur Google Play : 25 USD une seule fois.',
  support_cost_domain: 'Nom de domaine et hébergement du site mvplan.org.',
  support_cost_time: 'Le temps consacré au développement, aux tests et à la documentation du planificateur.',
  support_amount: 'Quelques euros suffisent. La plupart des participations vont de 3 à 10 euros, et c\'est déjà beaucoup.',
  support_nothing_unlocked: 'Participer ne débloque rien : pas de version payante, pas d\'option cachée, pas de nom affiché. L\'application reste la même pour tous.',
  support_thanks: 'Merci à celles et ceux qui ont déjà participé.',
  support_button: 'Participer',
  support_link_label: 'Adresse de la page',
  support_copy: 'Copier le lien',
  support_copied: 'Lien copié',
  support_copy_failed: 'Impossible de copier, sélectionnez l\'adresse à la main',
  support_open_hint: 'Si le bouton n\'ouvre rien, copiez l\'adresse ci-dessus dans votre navigateur.',
  support_website_title: 'Le projet',
  support_website_intro: 'MV-Plan est un logiciel libre, développé sur le temps libre de son auteur. Le site du projet regroupe la documentation, les notes de version et les moyens de contact.',
  support_website_button: 'Ouvrir le site du projet'
}
